<template>
  <!-- <div style="height:100%;overflow: hidden;"> -->
  <div>
    <div
      class="home"
      @scroll.passive="getScroll($event)"
    >
      <van-pull-refresh class="van_refresh"
        v-model="isLoading"
        @refresh="onRefresh"
        success-text="刷新成功"
      >
        <template #loosing>
          <div style="height:50px;">
            <i class="el-icon-loading"></i>
            下拉刷新
          </div>
        </template>
        <div style="height: 4.9rem; overflow: hidden">
          <img class="home-title" :src="backImg"/>
        </div>
        <div class="home-nav">
          <p @click="$router.push({ path: '/commonProblem' })">
            <img
              src="../../assets/img/Vector.png"
              alt
            />
            <span>常见问题</span>
          </p>
          <p @click="$router.push({ path: '/myPolitics',query: { webTenId: $route.query.webTenId}})" >
            <img
              src="../../assets/img/Group 2932.png"
              alt
            />
            <span>我的问政</span>
          </p>
        </div>
        <div class="home-center">
          <div class="home-center-nav">
            <van-dropdown-menu style="width: 100%">
              <van-dropdown-item
                v-model="formData.webBilType"
                :options="option1"
                @change="screen"
              />
              <van-dropdown-item
                v-model="formData.webClasId"
                :options="allClassList"
                @change="getCompany"
                :disabled="classDis"
              />
              <van-dropdown-item
                v-model="formData.webPolId"
                :options="unitOptions"
                :disabled="unitDis|| formData.webClasId == null"
                @change="screen"
              />
            </van-dropdown-menu>
          </div>
          <div v-if="list.length>0">
            <div
              v-for="(item, index) in list"
              :key="index"
              class="home-list"
              @click="
                $router.push({
                  path: '/politicsDetail',
                  query: {
                    webTenId: $route.query.webTenId,
                    id: item.webBilId,
                    webClasId:$route.query.webClasId,
                    webPolId:$route.query.webPolId
                  },
                })
              "
            >
              <p class="home-list-title">
                <span style="margin-right: 5px">[{{ item.webBilTypeName }}]</span>
                {{ item.webBilTitle }}
              </p>
              <p class="home-list-center">{{ item.webBilContent }}</p>
              <div class="home-list-bottom">
                <p>
                  <span style="margin-right: 0.24rem">
                    {{
                    item.webPlatName
                    }}
                  </span>
                  <span>{{ item.acceptTime }}</span>
                </p>
                <span :style="item.webBilStatus | backgroundList">
                  {{
                  item.webBilStatus | status
                  }}
                </span>
              </div>
            </div>
          </div>
          <div
            v-else
            style="    font-size: .32rem;
    text-align: center;
    padding: 4rem 0;"
          >暂无数据</div>
        </div>
      </van-pull-refresh>
    </div>

    <div class="home-bottom">
      <van-button
        round
        block
        type="primary"
        @click="openMyRespont()"
      >我要反映</van-button>
    </div>
    <div
      class="backTop"
      v-show="top"
      @click="backTop"
    >
      <van-icon
        name="back-top"
        size="20"
      />
      <span>顶部</span>
    </div>
  </div>
</template>

<script>
import ColorThief from "colorthief";
import {
  subscriptionManagerPage,
  subscriptionPage,
  politicsPage
} from "@/api/onternetPolitics/index.js";
import { filePerviewPath } from "@/api/globalApi.js";
import { weChatSharing } from "@/utils/app.js";
export default {
  data() {
    return {
      formData: {
        webBilType: null,
        webClasId: null,
        webPolId: null,
        pageNum: 1,
        excludeBilStatus: 0
      },
      option1: [
        { text: "类型", value: null },
        { text: "咨询", value: 0 },
        { text: "建议", value: 1 },
        { text: "投诉", value: 2 },
        { text: "求助", value: 3 },
        { text: "其他", value: 4 }
      ],
      isLoading: false, //下拉刷新
      loading: true, //下来加载
      finished: false,
      count: 3,
      list: [],
      unitOptions: [],
      allClassList: [],
      top: false,
      colors:'',
      classDis:false, // 类型是否可以筛选
      unitDis:false, // 单位是否可以筛选
      backImg:'',
    };
  },
  filters: {
    status: function (value) {
      switch (value) {
        case 2:
          return "未回复";
          break;
        case 4:
          return "已回复";
          break;
        case 1:
          return "已解决";
          break;
        case -1:
          return "不给予处理";
          break;
        case 3:
          return "待回复";
          break;
        default:
          return "获取失败";
      }
    },
    type: function (value) {
      switch (value) {
        case 0:
          return "咨询";
          break;
        case 1:
          return "建议";
          break;
        case 2:
          return "投诉";
          break;
        case 3:
          return "求助";
          break;
        default:
          return "其他";
      }
    },
    backgroundList: function (value) {
      switch (value) {
        case 2:
          return "color:#D2382E;background:#FFE7E7";
          break;
        case 4:
          return "color:#666666;background:#F5F5F5";
          break;
        case 1:
          return "color:#4AC391;background:rgba(219, 248, 235, 0.80)";
          break;
        case -1:
          return "color:#999999;background:#F5F5F5";
          break;
        case 3:
          return "color:#4AC391;background:#DBF8EB";
          break;
        default:
          return "获取失败";
      }
    }
  },
  created() {
    localStorage.setItem("signat", window.location.href);
    weChatSharing();
    // this.getUntil(this.$route.query.webClasId);
  },
  mounted() {
    // if (!localStorage.getItem("webTenId")) {

    // }

    document.title = "问政";
    // let arr = document.getElementsByClassName("home")[0];
    // window.addEventListener("scroll", this.getScroll);
    // window.addEventListener("scroll", this.getScroll, true);
    
    


    // this.getPage();
    
    this.getOptions();

  },
  methods: {
    getBase64(url){
      return new Promise((resolve, reject) => {
          // 图片地址
          const image = new Image()
          // 设置跨域问题
          image.setAttribute('crossOrigin', 'anonymous')
          // 图片地址
          image.src = url
          image.onload = () => {
            const canvas = document.createElement('canvas')
            const ctx = canvas.getContext('2d')
            canvas.width = image.width
            canvas.height = image.height
            ctx.drawImage(image, 0, 0, image.width, image.height)
            // 获取图片后缀
            const ext = url.substring(url.lastIndexOf('.') + 1).toLowerCase()
            // 转base64
            const dataUrl = canvas.toDataURL(`image/${ext}`)
            resolve(dataUrl || '')
          }
      })
    },
    // 获取背景图
    getBackImg(backImg){
      let domImg = document.createElement('img')
      domImg.src = backImg
      domImg.crossOrigin = "anonymous"
      let colorthief = new ColorThief();
      domImg.addEventListener('load', () => {
        this.colors = colorthief.getPalette(domImg,2)[0];
        let backgroundBox = document.querySelector('.van_refresh')
        backgroundBox.style.backgroundColor="rgb(" + this.colors + ")"
      })
      
    },
    // 打开我要反映
    openMyRespont(){
      this.$router.push({ path: '/myRespont', query:{webTenId: this.$route.query.webTenId,webClasId:this.$route.query.webClasId,webPolId:this.$route.query.webPolId } })
    },
    //下拉刷新
    onRefresh() {
      this.finished = false;
      this.isLoading = true;
      this.list = [];
      this.formData.pageNum = 1;
      this.getPage();
      this.isLoading = false;
    },
    //获取单位
    getUntil(val) {
      subscriptionManagerPage({
        pageSize: 0,
        webPlatType: 1,
        webClasId: val,
        webPlatStatus: 1
      }).then(res => {
        if (res.data.code == 200 && res.data.data.length>0) {
          res.data.data.forEach(ele => {
            ele.text = ele.webPlatName;
            ele.value = ele.webPlatId;
          });
          
          this.unitOptions = [
            { text: "单位", value: null },
            ...res.data.data
          ];
          
          let result = this.unitOptions.find(res=>{
            return res.webPlatId == this.$route.query.webPolId
          })
          if (!result) {
            this.formData.webPolId = null
          }
          this.unitOptions.forEach(item=>{
            if (val && this.$route.query.webPolId && item.webPlatId == this.$route.query.webPolId) {
              if (this.classDis) {
                this.unitDis = true
                this.formData.webPolId = item.webPlatId
              }else{
                this.formData.webPolId = null
              }
            }
          })
        }else{
              this.unitOptions = [
                { text: "单位", value: null },
                ...res.data.data
              ];
            }
      }).finally(()=>{
        this.list=[]
        this.screen()
      })
    },
    // 获取分类下拉选择
    getOptions() {
      subscriptionPage({ pageSize: 0, webPlatType: 1 }).then(res => {
        if (res.data.code == 200) {
          res.data.data.forEach(ele => {
            ele.text = ele.webClasName;
            ele.value = ele.webClasId;
          });
          this.allClassList = [
            { text: "单位类型", value: null },
            ...res.data.data
          ];
          let result = this.allClassList.find(res=>{
            return res.webClasId == this.$route.query.webClasId
          })
          if (!result) {
            this.formData.webPolId = null
            this.getUntil()
          }else{
            this.allClassList.forEach(item=>{
              if (this.$route.query.webClasId && item.value == this.$route.query.webClasId) {
                this.classDis = true
                this.formData.webClasId = parseInt(this.$route.query.webClasId)
                this.getCompany(item.value)
              }else if(!this.$route.query.webClasId && item.value == null ){
                this.getUntil()
              }
            })
          }
        }
      });
    },
    //单位类型筛选单位
    getCompany(val) {
      if (val == null) {
        this.screen();
      }
      this.getUntil(this.formData.webClasId);
      this.formData.webPolId = null;
    },
    //获取问政列表
    getPage() {
      this.unitOptions.forEach(item=>{
        
        if (item.value==this.formData.webPolId) {
          if (item.webBackImg) {
            this.backImg = filePerviewPath({fileObjId:item.webBackImg,downType:'cover'})
          }else if (!item.webBackImg){
            this.backImg = require('@/assets/img/Group 2977.png')
          }
        }else if(this.formData.webPolId==null){
          this.backImg = require('@/assets/img/Group 2977.png')
        }
      })
      // console.log(this.backImg);
      this.getBase64(this.backImg).then(res=>{
        this.getBackImg(res)
      })
     
      politicsPage(this.formData).then(({ data }) => {
        if (data.code == 200) {
          if (data.data.list.length > 0) {
            this.finished = false;
            let listData = [...this.list, ...data.data.list];
            this.list = this.noRepeat(listData)
          } else {
            this.finished = true;
          }
        }
      });
    },
    noRepeat(arr) {
        let list = [];
        return arr.filter((item) => !list.includes(item.webBilId) && list.push(item.webBilId))
    },
    //筛选
    screen() {
      this.list = [];
      // this.finished = false;
      this.formData.pageNum = 1;
      this.getPage();
    },
    getScroll(event) {
      // console.log(event);
      let scrollBottom =
        event.target.scrollHeight -
        event.target.scrollTop -
        event.target.clientHeight;
      // console.log(event.target.scrollTop);
      // this.scrollTop = event.target.scrollTop;
      // console.log(scrollBottom);
      if (event.target.scrollTop > 200) {
        this.top = true;
      } else {
        this.top = false;
      }
      if (scrollBottom == 0 && !this.finished) {
        
        this.formData.pageNum++;
        this.getPage();
      }
    },
    backTop() {
      document.getElementsByClassName("home")[0].scrollTop = -100;
    }
  }
};
</script>

<style lang="scss" scoped>
.home {
  // background: #d73434;
  // padding-bottom: 2.06rem;
  // max-height: 100%;
  overflow-y: scroll;
  scroll-behavior: smooth;
  max-height: 100vh;
  box-sizing: content-box;
  // overflow: auto;
  // overflow: auto;
  .home-title {
    width: 100%;
  }
  .home-nav {
    background: #fff;
    width: 91.5%;
    margin: 0 auto;
    border-radius: 0.2rem;
    display: flex;
    justify-content: space-around;
    padding: 0.32rem 0;
    margin-bottom: 0.24rem;
    p {
      display: flex;
      flex-direction: column;
      align-items: center;

      img {
        width: 0.56rem;
        margin-bottom: 0.12rem;
      }
    }
    span {
      font-size: 0.28rem;
    }
  }
  .home-center {
    background: #fff;
    width: 91.5%;
    margin: 0 auto;
    border-radius: 0.2rem;
    min-height: 450px;
    // overflow: hidden;
    // min-height: 6rem;
    .home-list {
      padding: 0 0.32rem 0.54rem;
      border-bottom: 1px solid #f2f2f2;
      margin-bottom: 0.4rem;
      /deep/ .van-cell__value {
        overflow: initial !important;
      }
      .home-list-title {
        color: #333333;
        font-weight: 600;
        font-size: 0.32rem;
      }
      .home-list-center {
        margin: 0.2rem 0;
        font-size: 0.28rem;
        color: #999999;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box; //将对象作为弹性伸缩盒子模型显示。
        -webkit-box-orient: vertical; // 从上到下垂直排列子元素
        -webkit-line-clamp: 2;
      }
      .home-list-bottom {
        font-size: 0.24rem;
        color: #999999;
        display: flex;
        align-items: center;
        justify-content: space-between;
        > p {
          max-width: 77%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        > span {
          padding: 0.06rem 0.14rem 0.06rem 0.24rem;
          border-radius: 0.4rem 0 0 0.4rem;
          position: relative;
          right: -0.32rem;
        }
      }
    }
    :last-child {
      border-bottom: none;
    }
  }
}
.home-bottom {
  position: fixed;
  bottom: 0.94rem;
  width: 5.56rem;
  transform: translateX(-50%);
  left: 50%;
  /deep/.van-button--primary {
    border: 1px solid rgba(255, 135, 67, 0.25) !important;
    background: linear-gradient(
      90deg,
      #f96443 0%,
      rgba(239, 109, 53, 0.8) 100%
    );
  }
  /deep/.van-button--normal {
    font-size: 0.32rem !important;
  }
}
/deep/.van-popup--top {
  width: 6.85rem !important;
  left: 50% !important;
  transform: translateX(-50%) !important;
  box-shadow: 0.06rem 0.24rem 0.24rem -0.14rem rgba(131, 131, 131, 0.25);
  border-radius: 0px 0px 0.2rem 0.2rem;
}
.backTop {
  height: 1.2rem;
  width: 1.2rem;
  border-radius: 50%;
  background: #f4f4f499;
  position: fixed;
  bottom: 3.86rem;
  right: 0.1rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  > span {
    font-size: 0.24rem;
    color: #333333;
  }
}
/deep/.van-pull-refresh__track {
  // height: 100vh;
}
/deep/.van-dropdown-menu__bar {
  border-radius: 0.2rem 0.2rem 0 0.2rem;
  box-shadow: none;
  // border-bottom: 1px solid rgba(131, 131, 131, 0.25);
}
/deep/.van-overlay {
  background: none !important;
}
/deep/.van-dropdown-menu__title {
  max-width: 80%;
}
.van-pull-refresh {
  background: #fff;
}
/deep/.van-pull-refresh__track {
  padding-bottom: 2.06rem;
  // height: calc(100vh - 2.06rem);
}
</style>